import RowLabel from '@/main/components/common/rowLabel/rowLabel';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KOGImage from '@/main/components/shared/kogImage/kogImage';
import WrapperQuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';
import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';
import { KeyValueDefault } from '@/main/models/common';
import { GetItemsCancelledBySupplierResponse } from '@/main/models/response';
import { RequoteCancelledPartsForm } from '@/main/screens/order/cancelledParts/components/modalRequotePartsCancelled/modalRequotePartsCancelledUtils';
import { getTranslateByKey } from '@/main/services/utils';
import { useFormContext } from 'react-hook-form';
import * as S from './styles';

interface IRowItemRequoteCancelled {
  partData: GetItemsCancelledBySupplierResponse;
  index: number;
  partTypeOptions: KeyValueDefault[];
}

export default function RowItemRequoteCancelled({
  index,
  partData,
  partTypeOptions
}: Readonly<IRowItemRequoteCancelled>) {
  const { control, setValue } = useFormContext<RequoteCancelledPartsForm>();

  return (
    <S.Container>
      <KOGImage src={partData.image} alt="" />
      <S.AreaTitlePart>
        <TooltipComponent
          interactive
          placement="top-start"
          title={
            <div>
              <RowLabel
                label={getTranslateByKey('information.claimNumber')}
                content={partData.claimNumber}
              />
              <RowLabel
                label={getTranslateByKey('information.order')}
                content={partData.procurementCode}
              />
              <RowLabel
                label={getTranslateByKey('information.quote')}
                content={partData.quoteCode}
              />
              <RowLabel
                label={getTranslateByKey('information.supplier')}
                content={partData.supplierName}
              />
              <RowLabel
                label={getTranslateByKey('information.vehicle')}
                content={partData.vehicleFullName}
              />
            </div>
          }>
          <div style={{ minWidth: 0, overflow: 'hidden', width: '100%' }}>
            <WrapperQuoteProcurementPartInfo
              data={partData.quoteProcurementPartInfo}
              renderType="column"
            />
          </div>
        </TooltipComponent>

        <KogAutoCompleteControlled
          id={`id-cancelledPartsRequote-select-partType-${index}`}
          nameCustom={`parts.${index}.partType`}
          control={control}
          isDefaultValueUnique
          valueDefaultKey={partData.quoteProcurementPartInfo.idPartType}
          setValueCustom={setValue}
          options={partTypeOptions}
          onChangeCustom={() => {}}
        />
      </S.AreaTitlePart>

      <S.Quantity>{partData.quantity}</S.Quantity>
    </S.Container>
  );
}
